module.exports = __webpack_public_path__ + "static/media/info-thick.391208da.svg";